(function (Drupal, $) {
  Drupal.behaviors.menu = {
    attach: function attach(context) {

      // The flyout's buttons also carry data-toggle, but sidebar.js owns them.
      $(context).find("[data-toggle]").not("[data-toggle='mobile-menu-open']").click(function (event) {
        const target = $(this).attr('data-toggle-target');
        const value = $(this).attr('data-toggle');
        $(target).toggleClass(value);

        // Close button on slide out menu
        if($(this).hasClass('burger-close')) {
          $(context).find("[data-toggle='user-menu-open']").attr('aria-expanded', false);
        } else {
          // Main Sign In or User name Click
          if($(this).attr('aria-expanded') === true) {
            $(this).attr('aria-expanded', false);
            $(context).find("[data-toggle='user-menu-open']").attr('aria-expanded', false);
          } else {
            $(this).attr('aria-expanded', true);
            $(context).find("[data-toggle='user-menu-open']").attr('aria-expanded', true);
          }
        }
        event.preventDefault();
        return false;
      });

      // Main Categories slider
      if ($(context).find(".field__field-menu").length) {

        // Need to show favorites based on the user's local time:
        //                         12 hour         /  24 hour
        // Breakfast favorites  -> 5am - 11am      /  5 - 11
        // Lunch favorites      -> 11:01am - 3pm   /  11:01 - 15
        // Dinner favorites     -> 3:01pm - 8pm    /  15:01 - 20
        // Munchies             -> 8:01pm - 4:59am /  20:01 - 24 & 0 - 4:59
        let timeCheck = [];
        timeCheck.breakfast = ['5:00', '11:00'];
        timeCheck.lunch = ['11:01', '15:00'];
        timeCheck.dinner = ['15:01', '20:00'];
        timeCheck.munchiespm = ['20:01', '24:00'];
        timeCheck.munchiesam = ['0:00', '4:59'];

        var now = new Date();

        // Use these to test different times
        // Breakfast Test
        // now.setHours(5);
        // now.setMinutes(30);

        // Lunch Test
        // now.setHours(11);
        // now.setMinutes(1);

        // Dinner Test
        // now.setHours(15);
        // now.setMinutes(1);

        // Munchies Test AM
        // now.setHours(0);
        // now.setMinutes(1);

        // Munchies Test PM
        // now.setHours(20);
        // now.setMinutes(1);

        var userTimeReadable = now.getHours() + ":" + now.getMinutes();
        var userTimeAsMinutes = timeToMinutes(now); // Minutes since Midnight

        // Determine what menu to show
        if(isBetweenTime(now, timeCheck.breakfast)) {
          showCategory('breakfast-favorites');
        } else if(isBetweenTime(now, timeCheck.lunch)) {
          showCategory('lunch-favorites');
        } else if(isBetweenTime(now, timeCheck.dinner)) {
          showCategory('dinner-favorites');
        } else if(isBetweenTime(now, timeCheck.munchiesam)) {
          showCategory('munchies');
        } else if(isBetweenTime(now, timeCheck.munchiespm)) {
          showCategory('munchies');
        }

        function isBetweenTime(timeToCheck, meal) {
          return timeToMinutes(timeToCheck) >= timeToMinutes(meal[0]) && timeToMinutes(timeToCheck) <= timeToMinutes(meal[1]);
        }

        function timeToMinutes(time) {
          if(time instanceof Date) {
            return time.getHours() * 60 + time.getMinutes();
          }
          let manualTime = time.split(':'); // split it at the colons
          return (+manualTime[0]) * 60 + (+manualTime[1]);
        }

        function showCategory(categoryIdentifier) {
          switch (categoryIdentifier) {
            case 'dinner-favorites':
              disableCategory('munchies');
              disableCategory('breakfast-favorites');
              disableCategory('lunch-favorites');
              break;
            case 'breakfast-favorites':
              disableCategory('munchies');
              disableCategory('dinner-favorites');
              disableCategory('lunch-favorites');
              break;
            case 'lunch-favorites':
              disableCategory('munchies');
              disableCategory('breakfast-favorites');
              disableCategory('dinner-favorites');
              break;
            case 'munchies':
              disableCategory('dinner-favorites');
              disableCategory('breakfast-favorites');
              disableCategory('lunch-favorites');
              break;
            default:
              // Show the Munchies if something messes up
              disableCategory('dinner-favorites');
              disableCategory('breakfast-favorites');
              disableCategory('lunch-favorites');
          }
        }

        function disableCategory(categoryIdentifier) {
          // Not doing this approach
          // Hide the content? Requires more work for accessibility kb/readers to ignore the content
          // $('#'+categoryIdentifier+"-tab").attr('aria-hidden', true).hide();
          // $('#'+categoryIdentifier+"-tab").find('a').attr('tabindex', -1);
          // $('[aria-labelledby="'+categoryIdentifier+'-tab"]').hide();

          // Remove from DOM completely and kb/sr can't interact anymore
          $('#'+categoryIdentifier+"-tab").remove();
          $('[aria-labelledby="'+categoryIdentifier+'-tab"]').remove();
        }

        var swiper = new Swiper(".field__field-menu", {
          observer: true,
          slidesPerView: 3.5,
          spaceBetween: 5,
          breakpoints: {
            900: {
              slidesPerView: 7,
              spaceBetween: 1
            }
          },
          slideToClickedSlide: true,
          roundLengths: true,
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
          },
          a11y: {
            enabled: false
          },
          on: {
            init: function(_swiper) {
              setTimeout(() => {
                handleAriaForMenuCategoryTabs(_swiper);
              }, 100);
              listenForKeyboardForMenuSlides(_swiper);
            },
            slideChange: function(_swiper) {
              handleAriaForMenuCategoryTabs(_swiper);
            },
            click: function(_swiper) {
              // allow time for lottie.js to perform it's actions for active categories.
              setTimeout(() => {
                handleAriaForMenuCategoryTabs(_swiper);
              }, 100);
            }
          },
        });
      }

      // Enable Category Items Swiper on desktop and up
      const enabledBreakpoint = window.matchMedia('(min-width: 768px)');
      let swiperMenuItems;

      // Individual Category Items Slider
      if ($(context).find(".category__items-list").length && enabledBreakpoint.matches === true) {
        $('.category__items-list').each(function( i ) {
          let swiperMenuItems = new Swiper($(".category__items-list")[i], {
            observer: true,
            watchOverflow: true,
            breakpoints: {
              900: {
                slidesPerView: 4,
                spaceBetween: 20,
                slidesPerColumn: 1
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 38,
                slidesPerColumn: 1
              }
            },
            slideToClickedSlide: true,
            roundLengths: true,
            navigation: {
              nextEl: $(".menu-next")[i],
              prevEl: $(".menu-prev")[i],
            },
            watchSlidesProgress: true,
            observeParents: true,

            on: {
              init: function(_swiper) {
                handleAriaForMenuSlides(_swiper);
              },
              slideChange: function(_swiper) {
                handleAriaForMenuSlides(_swiper);
              },
              observerUpdate: function(_swiper) {
                handleAriaForMenuSlides(_swiper);
              }
            },
          });
        });
      } else if($(context).find(".category__items-list").length && enabledBreakpoint.matches === false) {
        // Destroy any Swipers related to the category items
        if ( swiperMenuItems !== undefined )
          swiperMenuItems.destroy( true, true );
      }
      // Make only visible slides not aria-hidden
      // Make all hidden slides' interactive content a negative tab index
      function handleAriaForMenuSlides(_swiper) {
        $(_swiper.$el).find('.swiper-slide').attr('aria-hidden', true);
        $(_swiper.$el).find('.swiper-slide').find('a').attr('tabindex', -1);
        $(_swiper.$el).find('.swiper-slide-visible').attr('aria-hidden', false);
        $(_swiper.$el).find('.swiper-slide-visible').find('a').attr('tabindex', 0);

        // Specific for menus
        // Ensure all hidden menu item slides are aria-hidden
        $('.category__items-list:not(.active)').find('.swiper-slide').removeClass('swiper-slide-visible').attr('aria-hidden', true);
      }

      function handleAriaForMenuCategoryTabs(_swiper) {
        $(_swiper.$el).find('.field-item__field-menu').attr('aria-selected', false);
        $(_swiper.$el).find('.field-item__field-menu').attr('tabindex', -1);
        $(_swiper.$el).find('.field-item__field-menu').attr('role', 'tab');
        $(_swiper.$el).find('.field-item__field-menu.active').attr('aria-selected', true);
        $(_swiper.$el).find('.field-item__field-menu.active').removeAttr('tabindex');

        //Set the correct tabindex for the tabpanel that is active
        $('.menu-items').find('.menu-swiper-container').removeAttr('tabindex');
        $('.menu-items').find('.menu-swiper-container.active').attr('tabindex', 0);

        // Ensure the view all link is always set to link role (gets changed by swiper to tab but is not a tab)
        $('.full-menu-link').attr('role', 'link').removeAttr('tabindex');
      }

      // Menu category select previous/next tabs with right/left arrows
      function listenForKeyboardForMenuSlides(_swiper) {
        var tabList = _swiper.$wrapperEl[0];
        tabList.addEventListener('keydown', function(e) {
          switch(e.key) {
            case 'ArrowLeft':
              selectPreviousTab($(tabList).children());
              break;

            case 'ArrowRight':
              selectNextTab($(tabList).children());
              break;

            // Not used
            // case 'Home':  // optional
            //   e.preventDefault();  // prevent page scroll
            //   _swiper.slideTo(0);
            //   break;
            //
            // case 'End':  // optional
            //   e.preventDefault();  // prevent page scroll
            //   _swiper.slideTo(_swiper.length - 1);
            //   break;
          }
        });
      }

      function selectTab(tabs, index) {
        // Deactivate all tabs
        tabs.each(function(tab) {
          $(tabs[tab]).attr('aria-selected', false);
          $(tabs[tab]).attr('tabindex', -1);
        });

        // Activate only the requested tab, and set focus to it
        $(tabs[index]).attr('aria-selected', true);
        $(tabs[index]).attr('tabindex', 0);
        // Do a "click" to trigger tab panel logic, like hiding the non active panels and revealing the correct panel
        $(tabs[index]).click();
        $(tabs[index]).focus();

      }

      function selectPreviousTab(tabList) {
        var activeTab = $(tabList).closest('.active');
        var activeTabIndex = $(tabList).index(activeTab);
        // Select the previous tab, wrapping to last tab if needed
        if(activeTabIndex > 0) {
          selectTab(tabList,activeTabIndex - 1);
        } else {
          selectTab(tabList,tabList.length - 1);
        }
      }

      function selectNextTab(tabList) {
        var activeTab = $(tabList).closest('.active');
        var activeTabIndex = $(tabList).index(activeTab);

        // Select the next tab, wrapping to first tab if needed
        if(activeTabIndex < tabList.length - 1) {
          selectTab(tabList,activeTabIndex + 1);
        } else {
          selectTab(tabList,0);
        }
      }
    }
  }
})(Drupal, jQuery);
